import axios from "axios";
import {
  stripeSubscriptionFail,
  stripeSubscriptionSuccess,
  stripeProductSuccess,
  stripeProductFail,
  stripeCustomerSuccess,
  stripeCustomerFail,
  stripeCustomerPaymentMethodSuccess,
  stripeCustomerPaymentMethodFail,
  stripeCustomerTransactionSuccess,
  stripeCustomerTransactionFail,
  stripeCustomerPaymentMethodsSuccess,
  stripeCustomerPaymentMethodsFail,
  stripeCustomerAllPaidInvoicesSuccess,
  stripeCustomerAllPaidInvoicesFail,
  stripeProductsSuccess,
  stripeProductsFail,
  stripePriceSuccess,
  stripePriceFail,
  stripeSubscriptionUpdateSuccess,
  stripeSubscriptionUpdateFail
} from "../constant";
import { Api } from "../../Config/config.js";
import { store } from "../store";

export const stripeSubscription = async (dispatch, subscriptionID) => {
  try {
    const response = await axios.post(`${Api}stripe/subscriptionByID/`, {
      subscriptionID: subscriptionID,

      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " + store.getState().authReducer.tokens.access.token,
      },
    });

    dispatch({
      type: stripeSubscriptionSuccess,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: stripeSubscriptionFail,
      payload: error.response.data,
    });
  }
};
export const stripeProductData = async (dispatch, productID) => {
  try {
    const response = await axios.post(`${Api}stripe/product/`, {
      productID: productID,

      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " + store.getState().authReducer.tokens.access.token,
      },
    });

    dispatch({
      type: stripeProductSuccess,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: stripeProductFail,
      payload: error.response.data,
    });
  }
};
export const stripeCustomerData = async (dispatch, customerID) => {
  try {
    const response = await axios.post(`${Api}stripe/customerByID/`, {
      customerID: customerID,

      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " + store.getState().authReducer.tokens.access.token,
      },
    });

    dispatch({
      type: stripeCustomerSuccess,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: stripeCustomerFail,
      payload: error.response.data,
    });
  }
};
export const stripeCustomerPaymentMethodData = async (
  dispatch,
  customerID,
  defaultPaymentMethod,
) => {
  try {
    const response = await axios.post(
      `${Api}stripe/customerPaymentMethodByID/`,
      {
        customerID: customerID,
        defaultPaymentMethod: defaultPaymentMethod,

        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer " + store.getState().authReducer.tokens.access.token,
        },
      },
    );

    dispatch({
      type: stripeCustomerPaymentMethodSuccess,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: stripeCustomerPaymentMethodFail,
      payload: error.response.data,
    });
  }
};
export const stripeCustomerTransactions = async (dispatch, customerID) => {
  try {
    const response = await axios.post(
      `${Api}stripe/customerTransactionsByID/`,
      {
        customerID: customerID,

        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer " + store.getState().authReducer.tokens.access.token,
        },
      },
    );

    dispatch({
      type: stripeCustomerTransactionSuccess,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: stripeCustomerTransactionFail,
      payload: error.response.data,
    });
  }
};
export const stripeCustomerAllPaymentMethodsData = async (
  dispatch,
  customerID,
) => {
  try {
    const response = await axios.post(
      `${Api}stripe/customerPaymentMethodsByID/`,
      {
        customerID: customerID,

        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer " + store.getState().authReducer.tokens.access.token,
        },
      },
    );

    dispatch({
      type: stripeCustomerPaymentMethodsSuccess,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: stripeCustomerPaymentMethodsFail,
      payload: error.response.data,
    });
  }
};
export const stripeCustomerAllPaidInvoicesData = async (
  dispatch,
  limit,
  customerID,
  status,
) => {
  try {
    const response = await axios.post(
      `${Api}stripe/customerAllPaidInvoicesByID/`,
      {
        limit: limit,
        customerID: customerID,
        status: status,
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer " + store.getState().authReducer.tokens.access.token,
        },
      },
    );

    dispatch({
      type: stripeCustomerAllPaidInvoicesSuccess,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: stripeCustomerAllPaidInvoicesFail,
      payload: error.response.data,
    });
  }
};
export const stripeProductsData = async (dispatch, limit, active) => {
  try {
    const response = await axios.post(`${Api}stripe/products/`, {
      limit: limit,
      active: active,

      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " + store.getState().authReducer.tokens.access.token,
      },
    });

    dispatch({
      type: stripeProductsSuccess,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: stripeProductsFail,
      payload: error.response.data,
    });
  }
};
export const stripePrice = async (dispatch, priceID) => {
  try {
    const response = await axios.post(`${Api}stripe/price/`, {
      priceID: priceID,

      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " + store.getState().authReducer.tokens.access.token,
      },
    });

    dispatch({
      type: stripePriceSuccess,
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: stripePriceFail,
      payload: error.response.data,
    });
  }
};
export const stripeSubscriptionUpdate = async (
  dispatch,
  currentSubID,
  updateSubID,
  SelectedPriceID,
  billingCycle,
) => {
  try {
    const response = await axios.post(`${Api}stripe/subscriptionUpdate/`, {
      currentSubID: currentSubID,
      updateSubID: updateSubID,
      SelectedPriceID: SelectedPriceID,
      billingCycle: billingCycle,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " + store.getState().authReducer.tokens.access.token,
      },
    });

    dispatch({
      type: stripeSubscriptionUpdateSuccess,
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: stripeSubscriptionUpdateFail,
      payload: error.response.data,
    });
  }
};
